import { Container } from '@/components/container/container';
import { Layout } from '@/components/layout/layout';
import { CapsizedText as Text } from '@/components/text/text';
import Link from 'next/link';
import { HomeLink } from './404';

function NewsletterConfirmation() {
  return (
    <Layout title="Newsletter confirmation">
      <Container
        css={{
          display: 'flex',
          height: '100%',
          textAlign: 'center',
          padding: '$10 0',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div>
          <Text as="h1" size={8}>
            Newsletter
          </Text>
          <Text as="p" size={6}>
            You&apos;ve succesfully subscribed
          </Text>

          <Link href="/" passHref>
            <HomeLink as="a">Bring me home</HomeLink>
          </Link>
        </div>
      </Container>
    </Layout>
  );
}

export default NewsletterConfirmation;
